import { memo, useEffect } from "react";
import { Modal, Button, Form, Space } from "antd";
import styled from "styled-components";
import { DisclaimerType } from "const";
import IntlMessages from "../Message/IntlMessages";
import DisclaimerMessage from "../Message/DisclaimerMessage";
import compact from "lodash/compact";

const SecondMarketHighRisk = ({ close, actions, state, ...modalProps }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!modalProps.visible) form.resetFields();
  }, [form, modalProps.visible]);

  function _onAccept() {
    const accepts = compact([state.fxRateCondition && state.riskLevelCondition && "SECOND_MARKET_INVESTMENT"]);

    close();
    actions?.onAccept && actions.onAccept(accepts);
  }

  function _onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }

  const renderMessage = (title, disclaimerCode) => (
    <LongParagraph>
      <Space direction="vertical" size={5}>
        <b>
          <IntlMessages id={title} />
        </b>
        <DisclaimerMessage code={disclaimerCode} style={{ textIndent: 20 }} dangerous />
      </Space>
    </LongParagraph>
  );
  return (
    <Modal {...modalProps}>
      {modalProps.visible && (
        <Form form={form} onFinish={_onAccept}>
          <div className="mnc-modal-disclaimer">
            <div className="modal-mnc-head">
              <h5 className="m-0">
                <IntlMessages id="global.investment-warn" />
              </h5>
              <Button className="btn button-ktb-close" onClick={_onCancel}>
                <i className="feather-icon icon-x"></i>
              </Button>
            </div>
            <div className="modal-mnc-body">
              <LongParagraphWrapper>
                <Space direction="vertical" size={20}>
                  {state?.riskLevelCondition === "Y" &&
                    renderMessage("pwm.bss.buy.accept.risk.title.risk-level", DisclaimerType.HighRisk)}
                  {state?.fxRateCondition === "Y" &&
                    renderMessage("pwm.bss.buy.accept.risk.title.fx-risk", DisclaimerType.FXRisk)}
                </Space>
              </LongParagraphWrapper>
            </div>
            <div className="modal-mnc-footer">
              <div className="row justify-content-center">
                <div className="col-6 ps-1 ps-md-2">
                  <div className="d-grid">
                    <Button data-accept-btn className="btn button-ktb-main" onClick={_onAccept}>
                      <IntlMessages id="global.accept-investment-terms" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default memo(SecondMarketHighRisk);

SecondMarketHighRisk.defaultProps = {
  title: null,
  footer: null,
  closable: false,
  maskClosable: false,
  visible: true,
};

const LongParagraphWrapper = styled.div`
  background-color: #f4f4f5;
  border-radius: 3px;
  padding: 20px;
  margin: 0px 20px;
  max-height: 55vh;
  overflow-y: auto;
  margin-bottom: 0px;
`;
const LongParagraph = styled.div`
  white-space: pre-wrap;
`;
